import React from 'react'
import { Separator } from '@fs/zion-ui'
import ZionForm from '@fs/zion-form'
import { useTranslation } from 'react-i18next'
import { SubmitButton } from '@fs/identity.js'
import { useLoginForm } from '../hooks'
import FormUsernamePassword from './FormUsernamePassword'
import { RecoveryProvider } from '../context'

export default function LoginForm() {
  const { methods, onSubmit } = useLoginForm()
  const {
    formState: { isSubmitting },
  } = methods
  const { t } = useTranslation()
  return (
    <RecoveryProvider>
      <ZionForm methods={methods} onSubmit={onSubmit}>
        <FormUsernamePassword />
        <Separator size="xs" />
        <SubmitButton emphasis="medium" fullWidth isSubmitting={isSubmitting} linkName="Sign In" id="login">
          {t('common-ui:sign-in.action', 'Sign In')}
        </SubmitButton>
      </ZionForm>
    </RecoveryProvider>
  )
}
